import React from 'react';
import { Col, Row, Skeleton, Table } from 'antd';
import { useGetCarServiceTransfersQuery } from '../../../store/apis/carService';
import ContentBoxWithHeader from '../../molecules/ContentBoxWithHeader';

const transactionColumns = [
	{
		title: '순번',
		dataIndex: 'duzonTransferRequestSequenceNo',
		key: 'duzonTransferRequestSequenceNo',
	},
	{
		title: '이체일자',
		dataIndex: 'duzonTransferRequestDate',
		key: 'duzonTransferRequestDate',
	},
	{
		title: '상태',
		dataIndex: 'duzonTransferRequestStatus',
		key: 'duzonTransferRequestStatus',
		render: (text: string) => {
			let status;
			switch (text) {
				case 'C':
					status = '이체전';
					break;
				case 'R':
					status = '이체중';
					break;
				case 'Y':
					status = '이체성공';
					break;
				case 'N':
					status = '취소';
					break;
				case 'F':
					status = '실패';
					break;
				case 'E':
					status = '오류';
					break;
				default:
					status = text;
			}
			return <span style={{ fontWeight: 'bold' }}>{status}</span>;
		},
	},
	{
		title: '금액',
		dataIndex: 'duzonTransferRequestPrice',
		key: 'duzonTransferRequestPrice',
	},
	{
		title: '예금주',
		dataIndex: 'duzonTransferRequestName',
		key: 'duzonTransferRequestName',
		render: (name: string) => {
			if (!name || name.length < 2) return name; // 이름이 너무 짧으면 그대로 반환

			let maskedName = '';
			if (name.length === 2) {
				maskedName = `*${name[1]}`; // 2글자일 경우 첫 글자만 마스킹
			} else {
				const midIndex = Math.floor((name.length - 1) / 2); // 중간 위치 찾기
				maskedName = `${name.substring(0, midIndex)}*${name.substring(
					midIndex + 1,
				)}`;
			}

			return maskedName;
		},
	},
	{
		title: '계좌번호',
		dataIndex: 'duzonTransferRequestAccount',
		key: 'duzonTransferRequestAccount',
		// render: (text: string) => {
		// 	if (text && text.length > 4) {
		// 		const masked = `${text.slice(0, 2)}****${text.slice(-4)}`;
		// 		return masked;
		// 	}
		// 	return text;
		// },
	},
	{
		title: '은행',
		dataIndex: 'duzonTransferRequestBank',
		key: 'duzonTransferRequestBank',
	},
	{
		title: '지급확인일',
		dataIndex: 'duzonTransferConfirmationDate',
		key: 'duzonTransferConfirmationDate',
	},

	{
		title: '지급확인메모',
		dataIndex: 'duzonTransferRequestMemo',
		key: 'duzonTransferRequestMemo',
	},
];

interface TransferHistoryTabPaneProps {
	inspectionId: string | undefined;
}

const TransferHistoryTabPane = ({
	inspectionId,
}: TransferHistoryTabPaneProps) => {
	const { isLoading: isTransfersInfoLoading, data: transfersInfoData } =
		useGetCarServiceTransfersQuery({ inspectionId }, { skip: !inspectionId });

	const transfersInfo = transfersInfoData ? transfersInfoData.rows : [];

	return (
		<Row gutter={[6, 6]}>
			<Col span={24}>
				<ContentBoxWithHeader
					title="계좌이체 결과"
					borderRadius="10px"
					$isCompact
				>
					{isTransfersInfoLoading ? (
						<Skeleton active />
					) : (
						<Table
							dataSource={transfersInfo}
							columns={transactionColumns}
							size="small"
							pagination={{ pageSize: 5 }}
							rowKey={(record) => record.duzonTransferRequestSequenceNo}
						/>
					)}
				</ContentBoxWithHeader>
			</Col>
		</Row>
	);
};

export default TransferHistoryTabPane;
